<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-around;
  li{
    width: 190px;
    height: 188px;
    //margin-right:100px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 70px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
  background-size: 100% 100%;
}
.result-box {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 50%;
    text-align: center;
    .title {
      font-size:16px;
      margin:1.5em 0 3em 0 ;
    }
    img {
      height:400px;
    }
  }
}
.workflow-img{
  width: 100%;
  margin: 2vw auto;
  padding: 0 40px;
}
@media screen and (max-width: 640px)
{
  .container100{
    margin-bottom: 20px!important;
  }
  .effect-lists{
    justify-content: flex-start!important;
  }
  .result-box {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 100%;
      .title {
        font-size:14px;
        margin:0.5em 0 1em 0 ;
      }
      img {
        height:200px;
      }
    }
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/转录组测序/banner.png" alt="转录组测序服务" title="转录组测序服务" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons"  v-if="!$route.meta.invisibles">
      <img src="@/assets/img/二级标题Banner/转录组测序.jpg" alt="转录组测序服务" title="转录组测序服务" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" >
        <p class="desc">转录组是指在某一特定发育时期或者某一特定生理条件下，细胞内所有转录的RNA产物的集合，包括mRNA、LncRNA和环状RNA等。转录组具有时间特异性、组织特异性、空间特异性等特点。通过高通量测序技术进行转录组学研究可以快速获得特定组织或细胞在某一状态下所有转录本的序列信息和表达信息，从而准备的分析基因表达情况和样本间基因表达差异、基因结构变异、筛选分子标记等生命科学的重要问题。转录组测序已经被广泛应用于基础生命科学研究、临床医学诊断和药物研发等领域。擎科生物凭借现有的高通量测序技术和专业的转录组分析团队，可提供真核、原核转录组测序系列技术服务。</p>
      </div>
      <div class="container">
        <en-title title="转录组测序服务" enTitle="Transcriptome Sequencing Service"></en-title>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/zl_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/zl_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 项目实验流程 -->
      <div class="container">
        <en-title title="项目实验流程" enTitle="Workflow" />
        <p class="desc">
          擎科生物转录组测序可以为广大研究人员提供从样本制备建议、核酸提取、建库测序、数据分析等完整的全流程实验服务，保证高质量数据的同时为研究者后续研究保驾护航。
        </p>
        <img class="workflow-img" src="@/assets/images/ngs_second/transcriptome/sequencing/workflow_1.png" alt="转录组测序-项目实验流程"/>
      </div>
      <!-- 结果展示 -->
      <div class="container">
        <en-title title="结果展示" enTitle="Results" />
        <div class="result-box">
          <div class="item" v-for="(item,index) of resultList" :key="index">
            <img :src="getUrl(index)" class="img" :alt="item">
            <p class="title">{{ item }}</p>
          </div>
        </div>
      </div>
      <div class="compose-type1" style="margin-top: 60px;">
        <div class="container">
          <en-title title="服务优势" enTitle="Service Advantage" />
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/转录组测序/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.从文库构建、优化到测序数据精准分析,保证建库质量,提供个性化分析方案;</p>
                <p class="mb20">2.专业生物信息学分析团队,提供全面、精准、高质量的转录组分析结果;</p>
                <p class="mb20">3.周期短,按时交付,完善的一对一售前、售后服务,科研无忧。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <en-title title="资源中心" enTitle="Resource Center"></en-title>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <en-title title="相关服务" enTitle="Related Services" />
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons " style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <new-consult
          title="样本制备与寄样"
          enTitle="Sample Requirement and Shipment"
          :samplingText="samplingText"
          :typeList="['sampling']"
        />        
    <!-- <qk-consult type="Virus"/> -->
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
import EnTitle from '@/components/EnTitle'
export default {
  components:{
    bread,
    EnTitle
  },
  data () {
    return {
      samplingText: "擎科生物转录组测序目前接收细胞、动物组织、植物组织、真菌菌体、细菌菌体、血液等组织样本与提取好的total RNA。",
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'Sanger测序', img: '1', ref: '/sanger'},
        {name: '微生物测序', img: '3', ref: '/products/Microbial_sequencing'},
        {name: '基因组测序', img: '2', ref: '/products/Genome_sequencing'},
        {name: 'Fast NGS', img: '5', ref: '/tec/1.5_generation_sequencing'},
      ],
      types1: [
        {name: '真核转录组测序', img: '1', ref: '/tec/eukaryotic'},
        {name: '原核转录组测序', img: '2', ref: '/tec/prokaryotic'},
        {name: '全转录组测序', img: '3', ref: '/tec/whole_transciptome'},
        {name: '全长转录组测序', img: '4', ref: '/tec/full_length'},
        {name: 'LncRNA测序', img: '5', ref: '/tec/lncRNA'},
        {name: 'Small RNA测序', img: '6', ref: '/tec/smallRNA'},
      ],
      resultList: [ 
        "数据质控", 
        "PCA分析", 
        "差异分析火山图", 
        "差异分析热图", 
        "差异分析KEGG富集气泡图", 
        "GSEA分析"
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  computed: {
    getUrl() {
      return (index) => {
        return require(`@/assets/images/ngs_second/transcriptome/sequencing/result_${index+1}.png`)
      }
    },
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Transcriptome_sequencing.vue